import { FC } from 'react';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import { selectMealLineItems } from 'lib/home/util/products';
import { MyOrdersQuery } from 'lib/home/generated/types/api';
import { ProductRating } from '.';
import { ProductPayment } from './ProductPayment';
import { selectCardInfoFromMedusaOrder } from '../../util/helpers';
import { RatingInfoProps } from '../Modals/ProductRatingModal/ProductRatingModal';

export interface OrderHistoryProps {
  index: number;
  order: MyOrdersQuery['customerOrders'][number];
  showOrder: MyOrdersQuery['customerOrders'][number] | null;
  setDisplayedOrderId: React.Dispatch<React.SetStateAction<number>>;
  setRatingModal: (props: { isOpen: boolean; ratingInfo: RatingInfoProps }) => void;
}

export const OrderHistoryDate: FC<OrderHistoryProps> = ({
  order,
  showOrder,
  setDisplayedOrderId,
  setRatingModal,
  index
}) => {
  const { last4, brand } = selectCardInfoFromMedusaOrder(order);
  const orderPlan = order.cart.items.find(item => item?.variant?.product?.collection?.handle === 'subscriptions');
  const mealLineItems = showOrder ? selectMealLineItems(showOrder.cart.items) : [];
  // TODO: Show non-meal line items here also. https://lambdacurry.atlassian.net/browse/NHD-453

  return (
    <div className={classNames(showOrder?.id === order.id ? 'bg-brand-cool-gray-20 lg:h-[58px]' : 'bg-white')}>
      <div
        data-cy="order-date"
        className={classNames(
          showOrder?.id === order.id
            ? 'border-b-8 border-white lg:border-b-2 lg:border-gray-300'
            : 'border-b-2 border-gray-300',
          'gap-x-2 grid grid-cols-2 sm:grid-cols-4 p-4 hover:cursor-pointer mr-0 sm:pr-8'
        )}
        onClick={() => setDisplayedOrderId(order.display_id)}
      >
        <div>{DateTime.fromISO(order.cart.completed_at).toFormat('MM/d/y')}</div>
        <div>{order.display_id}</div>
        <div className="hidden sm:grid"> {orderPlan?.title ?? 'Individual Items'}</div>
        <div className="hidden sm:flex">
          <div className="mr-2 capitalize">{brand}</div>&nbsp;<div>{last4}</div>
        </div>
      </div>

      <div className=" p-0 lg:hidden">
        {showOrder?.id === order.id && (
          <div className="bg-gray-100">
            <ProductPayment order={order} />
            <h3 className="px-4 pb-2">Order Details</h3>
            {mealLineItems.map((item, index) => (
              <ProductRating
                lineItem={item}
                setRatingModal={setRatingModal}
                orderId={order.id}
                index={index}
                key={item.id}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
